import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'terms-of-service';

export const loadData = (params, search, config, preferredLanguage) => dispatch => {
  const pageAsset = { termsOfService: `content/pages/${ASSET_NAME}.json` };
  const language = preferredLanguage || config?.localization?.language;
  return dispatch(fetchPageAssets(pageAsset, true, language));
};
